module.exports = __webpack_public_path__ + "static/img/zhonghaida.993c1470.png";